import React, {PropsWithChildren} from 'react';
import {concepts} from "fearless-common";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import {CloudArrowDownFill} from "react-bootstrap-icons";
import {routes} from "../utils";
import useAuth from "./hooks/useAuth";
import trackEvent, {ACTIONS, CATEGORIES} from "./tracking/trackEvent";

type Props = PropsWithChildren<{
    className?: string;
    component?: typeof Nav.Link | typeof Button | 'a';
    actionTag?: ACTIONS;
    componentProps?: Record<string, any>;
}>
export default function TryForFreeButton({
    className = '',
    component: Component = Button,
    componentProps = {},
    actionTag,
    children
}: Props) {
    const { user } = useAuth()
    const url = user ? routes.download : routes.signUp;
    const label = user ? 'Download '+concepts.Photo51 : 'Try for free';

    return (
        <Component
            {...componentProps}
            className={className}
            // @ts-ignore
            to={url}
            href={url}
            onClick={() => {
                if (actionTag) trackEvent(CATEGORIES.SIGN_UP_CTA, actionTag, label);
            }}
        >
            {children || (
                <>
                    <CloudArrowDownFill size={30} />
                    &nbsp;&nbsp;{label}
                </>
            )}
        </Component>
    );
}
